import { render, staticRenderFns } from "./whitelabel.vue?vue&type=template&id=e1a46a46"
import script from "./whitelabel.vue?vue&type=script&lang=js"
export * from "./whitelabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports